// We hide UUID-shaped references from users (system movements stamp a raw row id
// into `reference`). Shape-only check — not strict RFC-4122 v4 — so non-v4 ids are
// still caught while human refs like "PO-12345" pass through unchanged.
const UUID_SHAPE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function looksLikeUuid(value: string): boolean {
  return UUID_SHAPE.test(value);
}

const UUID_IN_TEXT = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

// Stands in for a hidden id, so a request path still reads as one ("/patients/…/vitals").
export const MASKED_UUID = '…';

export function maskUuids(text: string): string {
  return text.replace(UUID_IN_TEXT, MASKED_UUID);
}

// Enough of an id to search the logs for, never the whole UUID.
const SHORT_ID_LENGTH = 8;

/** A UUID as its masked tail ("…2f8a9c10"); any other text with its UUIDs masked. */
export function shortenUuid(value: string): string {
  return looksLikeUuid(value) ? `${MASKED_UUID}${value.slice(-SHORT_ID_LENGTH)}` : maskUuids(value);
}
